import axios from '@/core/axios';

import { Team } from './teams.types';

export class TeamsService {
  list(): Promise<Team[]> {
    return axios.get<Team[]>('/teams').then(resp => resp?.data || []);
  }

  get(teamId: number | string): Promise<Team> {
    return axios.get<Team>(`/teams/${teamId}`).then(resp => resp?.data);
  }

  create(name: string): Promise<Team> {
    return axios.post<Team>('/teams', { name }).then(resp => resp?.data);
  }

  update(teamId: number | string, params: { name?: string; task_assignable?: boolean }): Promise<Team> {
    return axios.put<Team>(`/teams/${teamId}`, params).then(resp => resp?.data);
  }

  addRole(teamId: number | string, name: string): Promise<Team> {
    return axios.post<Team>(`/teams/${teamId}/roles`, { name }).then(resp => resp?.data);
  }

  removeRole(teamId: number | string, roleName: string): Promise<Team> {
    return axios.delete<Team>(`/teams/${teamId}/roles/${encodeURIComponent(roleName)}`).then(resp => resp?.data);
  }

  addUser(teamId: number | string, userId: number | string): Promise<Team> {
    return axios.post<Team>(`/teams/${teamId}/users`, { user_id: userId }).then(resp => resp?.data);
  }

  removeUser(teamId: number | string, userId: number | string): Promise<Team> {
    return axios.delete<Team>(`/teams/${teamId}/users/${userId}`).then(resp => resp?.data);
  }
}

export const teamsService = new TeamsService();
